import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=14f9bb5e&scoped=true"
import script from "./PaginationController.ts?vue&type=script&lang=ts&external"
export * from "./PaginationController.ts?vue&type=script&lang=ts&external"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=14f9bb5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f9bb5e",
  null
  
)

export default component.exports